// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const BACK_TO_HOMEPAGE = "Sp\u00e4\u0165 na hlavn\u00fa str\u00e1nku";
export const BLOGS_FEED_ALL = "V\u0161etky pr\u00edspevky";
export const BLOGS_FEED_FILTER_POST_TYPE = "Zobrazuj";
export const PB_MENU_ALBUMS = "Albumy";
export const PB_MENU_POSTS = "\u010cl\u00e1nky";
export const PB_MENU_SHORT_MESSAGES = "Kr\u00e1tke spr\u00e1vy";
export const PROFILE_BLOCKED__HEADER_username = "Pou\u017e\u00edvate\u013eka %(username)s u\u017e nem\u00e1 \u00fa\u010det na kon\u00edku.";
export const PROFILE_BLOCKED__REASON1_kodex = "poru\u0161ovanie %(kodex)s";
export const PROFILE_BLOCKED__REASON2 = "vytv\u00e1ranie viacn\u00e1sobn\u00fdch profilov";
export const PROFILE_BLOCKED__REASON3 = "na z\u00e1klade podozrenia z podvodn\u00fdch aktiv\u00edt";
export const PROFILE_BLOCKED__REASON4 = "na vlastn\u00fa \u017eiados\u0165";
export const PROFILE_BLOCKED__REASON5 = "vkladanie nepovolenej reklamy na str\u00e1nku";
export const PROFILE_BLOCKED__REASONS_ARE = "Naj\u010dastej\u0161ie je to z t\u00fdchto d\u00f4vodov:";
export const PROFILE__POSTS_FOR_REGISTRED_USERS_ARE_NOT_DISPLAYING_TO_YOU = "Pr\u00edspevky pre registrovan\u00fdch pou\u017e\u00edvate\u013eov sa ti nezobrazuj\u00fa.";
export const PROFILE_username_BLOCKED_BY_USER = "Pou\u017e\u00edvate\u013eka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modrom kon\u00edku. K tomuto kroku sa rozhodla sama pou\u017e\u00edvate\u013eka.";
export const RULES_KODEX__GENITIVE = "K\u00f3dexu spr\u00e1vania";
export const THIS_PHOTOBLOG_IS_STILL_EMPTY = "Tento profil je zatia\u013e pr\u00e1zdny";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
